export default "__VITE_PUBLIC_ASSET__ddacf2ee__"